import Products from "../../components/Products/Products";
import styles from "./ProductsPage.module.css";

export default function ProductsPage() {
  return (
    <div className={styles.page}>
      <Products />
    </div>
  );
}
